// extracted by mini-css-extract-plugin
export var cardHeader = "_hi-1";
export var contentCard = "_hi-0";
export var headerActions = "_hi-3";
export var reorderHandle = "_hi-5";
export var titleArea = "_hi-2";
export var titleAreaWithHandle = "_hi-4";